export default __webpack_public_path__ + "static/Montserrat-Regular-8a8585b953ff7f1d9e02c12782bd5715.eot";